export class ExpertFilters {




  public staticFilters;
  public optionalFilters;

  constructor(private entities){

    this.staticFilters = [
      {
        entity: this.entities.expert.entity,
        field: {
          name: 'enabled',
          type: 'select',
          label: 'Estado',
          width: 1,
          options: [
            {
              value:  -1,
              text: 'Todos'
            },
            {
              value:  0,
              text: 'Inactivo'
            },
            {
              value:  1,
              text: 'Activo'
            }
          ]
        }
      },
      {
        entity: this.entities.expert.entity,
        field: {
          name: 'name_complete',
          type: 'text',
          label: 'Nombre',
          width: 2
        }
      },
      {
        entity: this.entities.expert.entity,
        field: {
          name: 'address',
          type: 'text',
          label: 'Dirección',
          width: 2
        }
      },
      {
        entity: this.entities.expert.entity,
        field: {
          name: 'email',
          type: 'text',
          label: 'Email',
          width: 2
        }
      },

    ]

  }

}
